import React, { useState, memo } from 'react';
// import { useSelector } from 'react-redux';
import Subsidiaries from '../../../analysis/detail/subsidiaries';
import './styles.scss';

const LinkToLeSubsidiaries = () => {
  const [visible, setVisible] = useState(false);
  const onClick = () => {
    setVisible(true);
  };
  const onExpandChange = (expand) => {
    if (!expand) {
      setVisible(false);
    }
  };
  return (
    <>
      <a className="questionnaires-le-subsidiaries-link" onClick={onClick}>
        View LE Subsidiaries
      </a>
      {visible ? (
        <div className="questionnaires-le-subsidiaries-container">
          <Subsidiaries
            toggleLoading={false}
            onExpandChange={onExpandChange}
            initialExpand={true}
            showLoading={false}
            disableEdit
            mockFutureData
          />
        </div>
      ) : null}
    </>
  );
};

export default memo(LinkToLeSubsidiaries);
